import React from "react";
import "./banner.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import config from "../../config";

export default function Banner() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  return (
    <section
      className={`banner-section ${isVisible ? "animate" : ""}`}
      ref={ref}
    >
      <div className="container">
        {/* Banner Content */}
        <div className="banner-content-wrapper">
          <h1>Secure AI Framework Implementation for Enterprise Systems</h1>
          <p>
            SAIF Aviator: Delivering comprehensive AI security, risk assessment,
            and compliance solutions with automated controls, continuous
            monitoring, and advanced threat detection across your AI ecosystem.
          </p>
          <div className="banner-button-wrapper">
            <a href={config.bookdemo.Link}>
              <button className="banner-button">
                <p>Book Demo</p>
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
